import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { widget } from '~/charting_library';
import { createChartConfig } from '~/components/child/tradingViewMainChart/config/createChartConfig.js';
import { ImbalancesOperationClass } from '../../utils/classes/imbalanceProcessor/imbalancesOperationClass';
import { convertIntervalToTradingViewFormat } from '../../utils/converters/convertTimeFrameToTradingViewFormat';

import '../index.css';
import {
    createChartfavorites,
    createChartFavoritesSettingsAdapter
} from "~/components/child/tradingViewMainChart/utils/creators/createChartFavorites";

export const TVChartContainer = forwardRef(
  ({
       setChartIsReady,
       pair,
       setIsPlotZones,
       imbalanceValue,
       theme,
       mainChartFavorites,
       setMainChartFavorites,
       hasFavoriteChartDataChanged,
       setDataLoading,
       setError
   }, chartRef) => {
    const chartContainerRef = useRef();
    const { baseChartConfig, specificConfigs } = createChartConfig('imbalances');
    const tvWidgetRef = useRef();

    const [interval, setInterval] = useState('D');

    useImperativeHandle(chartRef, () => ({
      ImbalancesOperation,
    }));

    const tvChart = tvWidgetRef;
    const ImbalancesOperation = new ImbalancesOperationClass(tvChart, pair, imbalanceValue, setDataLoading, setError);

    useEffect(() => {
      const widgetOptions = {
        ...baseChartConfig?.defaultProps,
        container: chartContainerRef.current,
        datafeed: baseChartConfig?.createDatafeed(baseChartConfig?.datafeedUrl),
        disabled_features: specificConfigs?.disabledFeatures,
        enabled_features: specificConfigs?.enabledFeatures,
        theme: theme,
        symbol:`BINANCE:${pair}`,
        interval: interval,
        timeframe: { from: 1704054600, to: Math.floor(Date.now() / 1000) },
        favorites: createChartfavorites(mainChartFavorites),
        settings_adapter: createChartFavoritesSettingsAdapter(mainChartFavorites, setMainChartFavorites)
      };

      const tvWidget = new widget(widgetOptions);
      tvWidgetRef.current = tvWidget;

      tvWidget.onChartReady(() => {
        tvWidget.headerReady().then(() => {
            setChartIsReady(true)
          tvWidget
            .activeChart()
            .onIntervalChanged()
            .subscribe(null, (interval) => {
              setInterval(convertIntervalToTradingViewFormat(interval));
              try {
                ImbalancesOperation.removeAllWidget();
                setChartIsReady(false)
                setIsPlotZones(false);
              } catch (error) {
                setIsPlotZones(true);
                console.error('Change Interval Inbalances Error => ', error);
              }
            });
        });
      });

      return () => {
        setChartIsReady(false)
        tvWidget.remove();
        hasFavoriteChartDataChanged()
      };
    }, [pair, interval]);

    return <div data-testid="imbalances-chart" ref={chartContainerRef} className={'TVChartContainer'} />;
  }
);
TVChartContainer.propTypes = {
  setChartIsReady: PropTypes.func.isRequired,
  pair: PropTypes.string.isRequired,
  setIsPlotZones: PropTypes.func.isRequired,
  imbalanceValue: PropTypes.number.isRequired,
  theme: PropTypes.string.isRequired,
  mainChartFavorites: PropTypes.array.isRequired,
  setMainChartFavorites: PropTypes.func.isRequired,
  hasFavoriteChartDataChanged: PropTypes.func.isRequired,
  setDataLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired
};
